/**
 * App-wide environment configuration.
 * - Reads all environment variables needed for API, sockets, Azure AD, and storage.
 * - Provides defaults for local development if env vars are missing.
 * - Centralizes all URLs and keys for easy access and deployment.
 * - Used throughout the app for API endpoints, sockets, Azure authentication, and MinIO storage.
 */
const {
  REACT_APP_API_URL = "http://localhost:4400/graphql",
  SERVICE_API_URL = "http://localhost:4400",
  REACT_APP_SOCKET_URL = "ws://localhost:4400/graphql",
  REACT_APP_ENV = "development",
  REACT_APP_AZURE_CLIENT_ID = "c40b72eb-17ab-4328-896c-a554a93ca654",
  REACT_APP_AZURE_TENANT_ID = "4df928c2-c873-43b0-8bbc-f5a208d1e556",
  REACT_APP_MINIO_OBJECT_END_POINT = "http://13.127.144.184:9000/",
  REACT_APP_SUPER_ADMIN_ROLE_ID = "1,8",
} = process.env;

/**
 * ENV object holds all environment-specific configuration for the frontend.
 * - api_url: Main GraphQL endpoint.
 * - socket_url: WebSocket endpoint for GraphQL subscriptions.
 * - environment: Current environment (development, production, etc).
 * - service_url: REST API base URL.
 * - minio_bucket_url: MinIO object storage endpoint.
 * - azure: Azure AD authentication config (clientId, tenantId).
 */
export const ENV = {
  SUPER_ADMIN_ROLE_ID: REACT_APP_SUPER_ADMIN_ROLE_ID,
  api_url: REACT_APP_API_URL,
  socket_url: REACT_APP_SOCKET_URL,
  environment: REACT_APP_ENV,
  service_url: SERVICE_API_URL,
  minio_bucket_url: REACT_APP_MINIO_OBJECT_END_POINT,
  azure: {
    clientId: REACT_APP_AZURE_CLIENT_ID,
    tenantId: REACT_APP_AZURE_TENANT_ID,
  },
};
